import { getTestId } from '@airtel/air-design-system';
var data = [{
  iconName: 'FlightIcon',
  title: 'Travel',
  label: '4 complimentary lounge visits'
}, {
  iconName: 'PetrolPumpIcon',
  title: 'Fuel',
  label: 'Get 1% surcharge waiver'
}, {
  iconName: 'CouponIcon',
  title: 'Voucher',
  label: '₹600 activation benefits'
}];
export var defaultProps = Object.assign({
  data: data
}, getTestId('BenefitWidgetContainer'));